import React, { useState } from "react";

import { Container, Header } from "./styles";

//Custom components
import ProfileButton from "@components/ProfileButton/ProfileButton";
import PageLoading from "@components/PageLoading/PageLoading";

//Utils
import { Filter } from "@domain/models/Filters";
import useAllClients from "@hooks/useAllClients";
import { Paging } from "@domain/models/Paging";
import { tableColumns } from "@resources/tableColumns";
import Table from "@components/Table/Table";

function DatabasePage() {
  const [filters, setFilters] = useState<Filter[]>([]);

  const [paging, setPaging] = useState<Paging>({ offset: 0, limit: 25 });

  const { allClients, allClientsTotal } = useAllClients({
    filters: filters,
    paging,
  });

  if (allClients.length === 0) {
    return (
      <Container>
        <PageLoading />
      </Container>
    );
  }

  return (
    <Container>
      <Header>
        <div>
          <h1>Banco de dados</h1>
        </div>
        <div>
          <ProfileButton arrowColor="var(grey2)" />
        </div>
      </Header>

      <Table
        title="Banco de dados"
        tableColumns={tableColumns.database}
        tableRows={allClients}
        tableRowsTotal={allClientsTotal}
        filterTypes={[
          { headerName: "Operador", field: "operatorName" },
          { headerName: "Resultado", field: "lastReportResult" },
        ]}
        filters={filters}
        onChangeFilters={(newFiltersArray: Filter[]) => {
          setFilters(newFiltersArray);
        }}
        paging={paging}
        onChangePaging={(paging) => setPaging(paging)}
        columns={8}
        autoHeight={true}
        itemType="database"
        filtersHighlights={[
          { headerName: "Operador", field: "operatorName" },
          { headerName: "Resultado", field: "lastReportResult" },
        ]}
        dateField="lastReportDate"
      />
    </Container>
  );
}

export default DatabasePage;
